module.exports = __webpack_public_path__ + "static/media/IvanHu.fa121266.jpg";